import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaiuLeadRoutingModule } from './paiu-lead-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PaiuLeadRoutingModule
  ]
})
export class PaiuLeadModule { }
